import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/277'

const ActivationRateAtSelectLocationsTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="activation_rate.tabs.activation_rate_at_select_locations"
  />
)

export default ActivationRateAtSelectLocationsTab
